/**
 * Validation des redirections externes (paiement LKM / Malia Pay).
 */

const DEFAULT_PAYMENT_HOSTS = [
  'malia-pay.com',
  'www.malia-pay.com',
  'sandbox.malia-pay.com',
  'pay.malia-pay.com',
  // Wave / Orange Money (redirections renvoyées par LKM pour WAVECI / OMCI)
  'wave.com',
  'pay.wave.com',
  'orange-money.com',
  'patrimoneabygwem.com',
  'test.patrimoneabygwem.com',
  'test.patrimoneabygwem.com',
];

function paymentHostAllowlist() {
  try {
    const raw = typeof process !== 'undefined' && process.env?.VUE_APP_PAYMENT_URL_HOSTS;
    if (raw && String(raw).trim()) {
      return String(raw)
        .split(',')
        .map((h) => h.trim().toLowerCase())
        .filter(Boolean);
    }
  } catch (_) {}
  return DEFAULT_PAYMENT_HOSTS;
}

function hostMatchesAllowlist(hostname, allowlist) {
  const host = String(hostname || '').toLowerCase();
  if (!host) return false;
  return allowlist.some((allowed) => host === allowed || host.endsWith(`.${allowed}`));
}

/**
 * Redirection paiement : HTTPS uniquement, hôtes LKM/Malia/Patrimonea.
 */
export function isAllowedPaymentRedirectUrl(url) {
  try {
    const parsed = new URL(String(url || '').trim());
    if (parsed.protocol !== 'https:') return false;
    return hostMatchesAllowlist(parsed.hostname, paymentHostAllowlist());
  } catch {
    return false;
  }
}

/**
 * Chemins internes (router) — anti open-redirect.
 */
export function isSafeInternalPath(path) {
  let decoded = String(path || '').trim();
  if (!decoded) return false;
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    return false;
  }
  if (!decoded.startsWith('/') || decoded.startsWith('//')) return false;
  if (/[\x00-\x1f\\]/.test(decoded)) return false;
  if (decoded.includes('://')) return false;
  return true;
}
